export const API_BASE_URL = process.env.VUE_APP_API_BASE || 'https://remote-work-auth.cu-dbmi.dev/api'
export const DEFAULT_APP_TITLE = process.env.VUE_APP_DEFAULT_TITLE || 'Remote Work Authorization'
export const REMOTE_WORK_FORM = process.env.VUE_APP_REMOTE_WORK_FORM
